<ng-container *ngIf="isAction; else staticStatusChip">
  <button
    id="rideStatus-button-status"
    class="status-chip"
    [ngClass]="strippedStatus"
    uzDebounceClick
    (click)="handleRideStatusChipClicked()"
  >
    {{ status }}
  </button>
</ng-container>

<ng-template #staticStatusChip>
  <span id="rideStatusChip-text-rideStatus" class="status-chip" [ngClass]="strippedStatus">
    {{ status }}
  </span>
</ng-template>
